import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-swiper-acquired-card',
  templateUrl: './user-swiper-acquired-card.component.html',
  styleUrls: ['./user-swiper-acquired-card.component.scss']
})
export class UserSwiperAcquiredCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
